import { connect } from 'react-redux'
import { getCurrentCompanyPlans } from 'store/modules/user-session/selectors'
import { CompanyPlansSelect } from '../components'

export default connect((state) => ({
  list: getCurrentCompanyPlans(state),
}))(CompanyPlansSelect)
